// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__j3Xcu","content":"styles_content__mdKFi","spinner":"styles_spinner__MgAMq"};